import { EventEmitter } from 'events';
import { uuidGenerator } from '../../helpers/helpers';
import Util from './util';

let Vue;

const stomp = require('stompjs');

class BrokerPlugin extends EventEmitter {

  constructor(kauth) {
    super();
    this.kauth = kauth;
    this.client = stomp.client(process.env.VUE_APP_BROKER_URI);
    this.client.connect_retries = 0;
    this.client.debug = null; // msg => console.log(msg);
    this.connect();
  }

  async connect() {
    const token = await this.kauth.getValidToken();
    this.client.connect('#token', token, () => this.onConnect(), err => this.onError(err));
  }

  genUserQueueName() {
    return uuidGenerator(this.kauth.tokenParsed.preferred_username);
  }

  onConnect() {
    console.log('connected');
    this.emit('connected');
    // this.client.subscribe(this._replyQueue, msgData => this.onMessage(msgData), { ack: 'client-individual' });
  }

  waitConnection() {
    return new Promise((resolve) => {
      if (this.client.connected) resolve();
      else this.once('connected', resolve);
    });
  }

  async subscribe(destination, callback, opt = { ack: 'client-individual' }) {
    if (!this.client.connected) await this.waitConnection();
    return this.client.subscribe(destination, callback, opt);
  }

  async sendGCUCommand(code, gcuCode, replyQueue) {
    if (!this.client.connected) await this.waitConnection();
    const command = Util.buildCommandStringGCU(code, replyQueue);
    const headers = {
      'content-length': false,
      priority: '6',
      expires: new Date().getTime() + 600000
    };
    this.client.send(gcuCode, headers, command);
  }

  async sendGCUWithCommand(command, gcuCode) {
    if (!this.client.connected) await this.waitConnection();
    const headers = {
      'content-length': false,
      priority: '6',
      expires: new Date().getTime() + 600000
    };
    this.client.send(gcuCode, headers, command);
  }

  async sendLCUCommand(code, gcuCode, lcuCode, replyQueue) {
    if (!this.client.connected) await this.waitConnection();
    const command = Util.buildCommandStringLCU(code, lcuCode, replyQueue);
    this.client.send(gcuCode, { 'content-length': false, priority: '6' }, command);
  }

  async sendAllLCUCommand(code, gcuCode, replyQueue) {
    if (!this.client.connected) await this.waitConnection();
    const command = Util.buildCommandStringAllLCU(code, replyQueue);
    this.client.send(gcuCode, { 'content-length': false, priority: '6' }, command);
  }

  onMessage(data) {
    data.ack();
    this.emit('gcuMessage', data);
  }

  onError(err) {
    console.log(err);
    if (this.client == null || this.client.connected === false) {
      if (this.client.connect_retries < 5) {
        console.log('Re-Connecting');
        this.client.connect_retries++;
        this.connect();
      }
    }
  }

  // Vue specific code required to hide away 'installing' the broker functionality on the Vue prototype
  install(_Vue) {
    if (Vue && _Vue === Vue) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(
          '[broker] already installed. Vue.use(MessageBroker) should be called only once.'
        );
      }
      return;
    }
    Vue = _Vue;
    Vue.prototype.$broker = this;
  }

}

export default BrokerPlugin;
